import server from "api/server";
import React, { useState } from "react";
import imageUpload from "assets/svgs/imageUpload.svg";
import removeImg from "assets/svgs/close.svg";
import { FormattedMessage } from "react-intl";
import { handleImage } from "helpers/functions";

const ImageUpdateValue = ({
  title = "image",
  value,
  setValue,
  style = {},
  required = true,
}) => {
  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);

      const { data } = await server().post("/upload", formData);

      setValue(data?.data?.file.fullpath);

      e.target.value = null;
    }
  };

  const removeSelectedImage = () => {
    setValue("");
  };

  return (
    <div className={`form-group ${required ? "required" : ""}`}>
      <h5>
        <FormattedMessage id={title || " "} />
      </h5>

      <div className="image-uploader image-contain m-auto" style={style}>
        <div className="img-pat">
          <img src={imageUpload} width={46} height={46} alt="" />
        </div>
        <label>
          {value && (
            <div>
              <img src={handleImage(value)} width={160} height={160} alt="" />
              <button
                type="button"
                className="removeImg"
                onClick={removeSelectedImage}
              >
                <img src={removeImg} alt="" />
              </button>
            </div>
          )}
          <input accept="image/*" type="file" onChange={imageChange} />
        </label>
      </div>
    </div>
  );
};

export default ImageUpdateValue;
